import { client, handleRequest, handleRequestBody } from "./client.ts";

export interface JoinWaitlistRequest {
	name: string;
	email: string;
}

export async function joinWaitlist(req: JoinWaitlistRequest): Promise<void> {
	await handleRequest(() =>
		client.post("/waitlist", { name: req.name, email: req.email }),
	);
}

export interface WaitlistInvitePreview {
	email: string;
}

export function previewWaitlistInvite(
	token: string,
): Promise<WaitlistInvitePreview> {
	return handleRequestBody(() =>
		client.get<WaitlistInvitePreview>(
			`/waitlist/invites/${encodeURIComponent(token)}`,
		),
	);
}
